import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { getMonths, kFormatter } from "../../helpers";
import useLogout from "../../common/useLogout";
import { updateObjectInArray } from "../../../redux/reducers/helpers";
import { getTotalScoredUsers } from "../../../queries/metrics";
import isEmpty from "lodash/isEmpty";

const options = {
  legend: {
    display: false,
    position: "bottom",
  },
  tooltips: {
    intersect: false,
    xPadding: 15,
    yPadding: 15,
    callbacks: {
      label: function (t, d) {
        const dstLabel = d.datasets[t.datasetIndex].label;
        const yLabel = t.yLabel;
        return " " + dstLabel + ": " + yLabel;
      },
    },
  },
  scales: {
    xAxes: [
      {
        stacked: true,
        gridLines: {
          display: false,
        },
        ticks: {
          padding: 5,
        },
      },
    ],
    yAxes: [
      {
        stacked: true,
        gridLines: {
          drawBorder: false,
          zeroLineColor: "rgba(0,0,0,.5)",
        },
        ticks: {
          beginAtZero: true,
          padding: 15,
          callback: function (val) {
            return kFormatter(val);
          },
        },
      },
    ],
  },
};

const chartDataset = JSON.stringify({
  labels: getMonths(),
  datasets: [
    {
      label: "Scores calculated",
      data: [],
      backgroundColor: "#00cbd3",
      borderColor: "#00cbd3",
    },
  ],
});

const FinscoreFSScoresCalculatedBarChart = ({ cableApp, application }) => {
  const [handleLogout] = useLogout();
  const [dataset, setDataset] = useState(JSON.parse(chartDataset));

  const createDataset = (data) => {
    const message = data.message[0];
    dataset.datasets[0].data = message.datapoints;
    setDataset({
      ...dataset,
      datasets: updateObjectInArray(
        dataset.datasets,
        dataset.datasets[0],
        "label"
      ),
    });
  };

  const handleEmptyDataSet = () => {
    setDataset(JSON.parse(chartDataset));
  };

  useEffect(() => {
    cableApp["finscoreqs-scored-users"] = cableApp.cable.subscriptions.create(
      {
        channel: "ChartsChannel",
        chart_resource: "application-finscoreqs-scored-users",
        id: application.id,
      },
      {
        connected: () => {
          getTotalScoredUsers({
            id: application.id,
            service_name: "finscoreqs",
            chart_resource: "application-finscoreqs-scored-users",
          });
        },
        received: (data) => {
          if (!isEmpty(data.message[0])) {
            createDataset(data);
          } else {
            handleEmptyDataSet();
          }
        },
        rejected: () => {
          handleLogout();
        },
      }
    );
    return () => {
      cableApp["finscoreqs-scored-users"].unsubscribe();
    };
  }, []);

  return <Bar data={dataset} options={options} />;
};

FinscoreFSScoresCalculatedBarChart.propTypes = {};

export default FinscoreFSScoresCalculatedBarChart;
